/**
 * утилита для форматирования процентного значения, к формату с двумя или менее значениями после запятой
 * @param {number} coefficient - процентное значение, которое нужно отформатировать
 */
function formatPercent(coefficient: number): number {
  return Math.round(coefficient * 100) / 100;
}

export default formatPercent;
